import React from 'react';
import LogotypeComponent from 'styles/images/menigo_redwhitegrey_tagline.svg';
import * as styles from './base.scss';
export default class Logotype extends React.Component {
    render() {
        return !this.props.disableLink ? (React.createElement("a", { className: styles.logotype + ' ' + (this.props.className || ''), href: this.props.siteUrl },
            React.createElement(LogotypeComponent, null))) : (React.createElement("div", { className: styles.logotype + ' ' + (this.props.className || '') },
            React.createElement(LogotypeComponent, null)));
    }
}
